import { WritableSet } from "../../shared/WritableSet";
export class VehiclesManager {
    constructor(parent) {
        this.visibleVehicles = new WritableSet();
        this.parent = parent;
        this.parent.getVehicles().forEach(v => {
            this.visibleVehicles.add(v.id);
        });
    }
    getVehicles() {
        return this.parent.getVehicles();
    }
    getVisbleVehiclesStore() {
        return this.visibleVehicles;
    }
}
